import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card } from 'antd';
import ModelForm from './ModelForm';
import ItemBatchDetailActions from '../../Stores/ItemBatchDetail/Actions';

class ItemBatchDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, model } = this.props;

    return (
      <Card title={`${intl.formatMessage({ id: 'item' })} ${model.item_code}`}>
        <ModelForm match={match} />
      </Card>
    );
  }
}

ItemBatchDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    item_code: PropTypes.string
  })
};

ItemBatchDetailScreen.defaultProps = {
  intl: {},
  match: {},

  setReslId() {},
  model: { item_code: '' }
};

const mapStateToProps = state => ({
  model: state.itemBatchDetail.model
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(ItemBatchDetailActions.itemBatchDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ItemBatchDetailScreen));
